
import { Options, Vue } from 'vue-class-component';
import { ContentLoader } from 'vue-content-loader'

@Options({
  components: {
    ContentLoader,
  },
})
export default class loader extends Vue {
}
